import { render, staticRenderFns } from "./HistoryPanel.vue?vue&type=template&id=a89b87a0&scoped=true"
import script from "./HistoryPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./HistoryPanel.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./HistoryPanel.vue?vue&type=style&index=0&id=a89b87a0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a89b87a0",
  null
  
)

export default component.exports